import { initials } from '@/lib/utils';

type AnyProfile = { display_name?: string | null; handle?: string | null } | null | undefined;

export function displayName(p: AnyProfile): string {
  return p?.display_name || p?.handle || 'Member';
}

export function avatarBg(url?: string | null) {
  return url
    ? { backgroundImage: `url(${url})`, backgroundSize: 'cover', backgroundPosition: 'center' }
    : undefined;
}

export function avatarInitial(name?: string | null): string {
  return initials(name) || '?';
}

export function formatTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
}

export function estLabel(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString([], { month: 'short', year: 'numeric' });
}

export function priceLabel(cents: number): string {
  return cents > 0 ? `$${(cents / 100).toFixed(cents % 100 ? 2 : 0)}/mo` : 'Free';
}
